// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qc-list[data-v-16c2ef89]{padding:5px 0;cursor:pointer}.qc-list-active[data-v-16c2ef89]{background-color:#4285f4}", ""]);
// Exports
module.exports = exports;
